export function parseStages(stages) {
    if (Array.isArray(stages)) return stages;
    if (typeof stages === 'string') {
        try {
            const parsed = JSON.parse(stages);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    }
    return [];
}

function normalizeSteps(steps) {
    const seen = new Set();
    const normalized = [];
    parseStages(steps)
        .map((step) => parseInt(step, 10))
        .filter((step) => !isNaN(step))
        .sort((a, b) => a - b)
        .forEach((step) => {
            if (!seen.has(step)) {
                seen.add(step);
                normalized.push(step);
            }
        });
    return normalized;
}

export function groupIntoRuns(steps) {
    const sorted = normalizeSteps(steps);
    const runs = [];
    sorted.forEach((step) => {
        const last = runs[runs.length - 1];
        if (last && step === last.to + 1) {
            last.to = step;
        } else {
            runs.push({ from: step, to: step });
        }
    });
    return runs;
}

export function buildSetList(upperSteps, lowerSteps) {
    const sets = [];
    const pushRuns = (steps, arch) => {
        groupIntoRuns(steps).forEach((run) => {
            sets.push({ setNo: sets.length + 1, from: run.from, to: run.to, arch });
        });
    };
    pushRuns(upperSteps, 'Upper');
    pushRuns(lowerSteps, 'Lower');
    return sets;
}

export function computeDeliveredRange(upperSteps, lowerSteps) {
    const totalSets = buildSetList(upperSteps, lowerSteps).length;
    if (totalSets === 0) return null;
    return { param1: 1, param2: totalSets };
}
